var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgAttribution = function SvgAttribution(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#616161",
    d: "M20.348 4H3.652c-.863 0-1.565.764-1.565 1.703v13.624c0 .314.233.568.522.568H21.39c.289 0 .522-.254.522-.568V5.703c0-.94-.702-1.703-1.565-1.703z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E0E0E0",
    d: "M0 18.3v.777c0 1.073 1.17 1.946 2.609 1.946H21.39c1.439 0 2.609-.873 2.609-1.946V18.3H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M3.652 5.596h16.696v11.107H3.652z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#9E9E9E",
    d: "M13.565 19.895h-3.13a1.054 1.054 0 01-1.044-1.064V18.3h5.218v.532c0 .588-.468 1.064-1.044 1.064z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5ebfd5",
    d: "M12.522 7.66c.288 0 .521.238.521.532v6.915a.527.527 0 01-.521.532h-1.044a.527.527 0 01-.521-.532V8.192c0-.294.233-.532.521-.532h1.044zm-4.174 3.99c.288 0 .522.238.522.532v2.925a.527.527 0 01-.522.532H7.304a.527.527 0 01-.521-.532v-2.925c0-.294.233-.532.521-.532h1.044zm8.348-.998c.288 0 .521.238.521.532v3.923a.527.527 0 01-.521.532h-1.044a.527.527 0 01-.522-.532v-3.923c0-.294.234-.532.522-.532h1.044z"
  }))));
};
export default SvgAttribution;